import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["theme"];
import React from 'react';
import { Original } from "./Original.js";
import { Modified } from "./Modified.js";
import { Internal } from "./Internal.js";
import { Provider } from "./store.js";
import { jsx as _jsx } from "react/jsx-runtime";
var InternalCodeMirror = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      theme
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Provider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(Internal, _extends({}, props, {
      ref: ref
    }))
  });
});
var CodeMirrorMerge = InternalCodeMirror;
CodeMirrorMerge.Original = Original;
CodeMirrorMerge.Modified = Modified;
CodeMirrorMerge.displayName = 'CodeMirrorMerge';
export default CodeMirrorMerge;